import { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { WebPageSchema, BreadcrumbListSchema } from '@/components/feature/SchemaOrg';
import { categories } from '@/mocks/yihao';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(slug || 'live-casino');

  const currentCategory = categories.find((c) => c.slug === activeTab) || categories[0];

  useEffect(() => {
    if (slug) {
      setActiveTab(slug);
    }
  }, [slug]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [activeTab]);

  const handleTabChange = (newSlug: string) => {
    setActiveTab(newSlug);
    navigate(`/category/${newSlug}`);
  };

  return (
    <>
      <WebPageSchema
        title={`${currentCategory.name} - 壹号娱乐`}
        description={currentCategory.description}
        url={`https://bukedg.cn/category/${currentCategory.slug}`}
      />
      <BreadcrumbListSchema />

      <Navbar />
      <Breadcrumb items={[{ label: currentCategory.name }]} />

      <main>
        <section className="w-full px-6 md:px-10 py-6">
          <div className="max-w-7xl mx-auto">
            <div className="relative rounded-2xl overflow-hidden h-[240px] md:h-[320px] mb-10">
              <img
                src={currentCategory.image}
                alt={`壹号娱乐${currentCategory.name}`}
                title={`壹号娱乐${currentCategory.name}`}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 p-6 md:p-8">
                <h1 className="font-heading text-2xl md:text-4xl font-bold text-white mb-2">{currentCategory.name}</h1>
                <p className="text-white/80 text-sm md:text-base max-w-xl">{currentCategory.description}</p>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-2 mb-10 pb-4 border-b border-background-200/60 overflow-x-auto">
              {categories.map((cat) => (
                <button
                  key={cat.slug}
                  onClick={() => handleTabChange(cat.slug)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                    activeTab === cat.slug
                      ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  <i className={`${cat.icon} text-base`}></i>
                  {cat.name}
                </button>
              ))}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {currentCategory.articles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer border border-background-200/60 hover:border-primary-200 transition-all duration-300"
                >
                  <div className="relative h-52 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-5">
                    <h2 className="font-heading font-bold text-base text-foreground-900 mb-2.5 line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h2>
                    <p className="text-foreground-500 text-sm line-clamp-2 mb-4">{article.excerpt}</p>
                    <div className="flex items-center justify-between">
                      <span className="text-foreground-400 text-xs">{article.date}</span>
                      <span className="text-primary-500 text-xs font-medium flex items-center gap-1">
                        阅读全文 <i className="ri-arrow-right-line"></i>
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            {currentCategory.articles.length === 0 && (
              <div className="text-center py-20">
                <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-background-100 flex items-center justify-center">
                  <i className="ri-file-list-3-line text-3xl text-foreground-300"></i>
                </div>
                <h3 className="text-foreground-600 font-medium text-lg mb-2">暂无文章</h3>
                <p className="text-foreground-400 text-sm">该分类下暂无文章，请查看其他分类</p>
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
      <ScrollToTop />
    </>
  );
}